export interface ToolbarGroup {
  group: string;
  width?: number;
  options: {
    name: string;
    icon: string;
    selected: boolean;
    onClick: () => void;
    disabled?: boolean;
    shortcut?: string;
  }[];
}

export const toolbarGroups = (
  states: Record<string, boolean>,
  commands: Record<string, (...args: any) => void>
): ToolbarGroup[] => [
  {
    group: 'history',
    options: [
      {
        name: 'Undo',
        icon: 'arrow-turn-backward',
        selected: false,
        onClick: commands.onUndo,
        disabled: !states.canUndo,
        shortcut: 'CommandOrControl+Z',
      },
      {
        name: 'Redo',
        icon: 'arrow-turn-forward',
        selected: false,
        onClick: commands.onRedo,
        disabled: !states.canRedo,
        shortcut: 'CommandOrControl+Shift+Z',
      },
    ],
  },
  {
    group: 'text',
    options: [
      {
        name: 'Bold',
        icon: 'text-bold',
        selected: states.isBold,
        onClick: commands.onBold,
        shortcut: 'CommandOrControl+B',
      },
      {
        name: 'Italic',
        icon: 'text-italic',
        selected: states.isItalic,
        onClick: commands.onItalic,
        shortcut: 'CommandOrControl+I',
      },
      {
        name: 'Underline',
        icon: 'text-underline',
        selected: states.isUnderline,
        onClick: commands.onUnderline,
        shortcut: 'CommandOrControl+U',
      },
      {
        name: 'Strikethrough',
        icon: 'text-strikethrough',
        selected: states.isStrike,
        onClick: commands.onStrike,
        shortcut: 'CommandOrControl+Shift+S',
      },
    ],
  },
  {
    group: 'list',
    options: [
      {
        name: 'Numbered list',
        icon: 'left-to-right-list-number',
        selected: states.isOrderedList,
        onClick: commands.onOrderedList,
        shortcut: 'CommandOrControl+Shift+7',
      },
      {
        name: 'Bulleted list',
        icon: 'paragraph-bullets-point-02',
        selected: states.isBulletList,
        onClick: commands.onBulletList,
        shortcut: 'CommandOrControl+Shift+8',
      },
    ],
  },
  {
    group: 'code',
    options: [
      {
        name: 'Horizontal Rule',
        icon: 'keyframe-align-horizontal',
        selected: states.isHorizontalRule,
        onClick: commands.onHorizontalRule,
      },
      {
        name: 'Code',
        icon: 'source-code',
        selected: states.isCode,
        onClick: commands.onCode,
        shortcut: 'CommandOrControl+E',
      },
    ],
  },
  {
    group: 'paragraph',
    options: [
      {
        name: 'Align left',
        icon: 'text-align-left-01',
        selected: states.isAlignLeft,
        onClick: commands.onAlignLeft,
        shortcut: 'CommandOrControl+Shift+L',
      },
      {
        name: 'Align center',
        icon: 'text-align-center',
        selected: states.isAlignCenter,
        onClick: commands.onAlignCenter,
        shortcut: 'CommandOrControl+Shift+E',
      },
      {
        name: 'Align right',
        icon: 'right-to-left-block-quote',
        selected: states.isAlignRight,
        onClick: commands.onAlignRight,
        shortcut: 'CommandOrControl+Shift+R',
      },
      {
        name: 'Justify',
        icon: 'menu-01',
        onClick: commands.onJustify,
        selected: states.isJustified,
        shortcut: 'CommandOrControl+Shift+J',
      },
    ],
  },
];
